import ApiService from "../api.services";
import { RequestError } from "../users/user.services";

const CompaniesService = {
  getLogo: async function({ companyId, federalId }) {
    const queryFederalId = federalId ? `federalId=${federalId}` : "";
    const queryCompanyId = companyId ? `companyId=${companyId}` : "";
    let query = "";
    if (queryFederalId) query = `?${queryFederalId}`;
    if (queryCompanyId) {
      if (query.length !== 0) query += "&";
      else query += "?";
      query += `${queryCompanyId}`;
    }
    try {
      const response = await ApiService.get(`/companies/logo${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  add: async function({
    companyName,
    federalId,
    urlProtheus,
    headerProtheus,
    logo
  }) {
    const formData = new FormData();
    formData.append("name", companyName);
    formData.append("federalId", federalId);
    formData.append("urlProtheus", urlProtheus);
    formData.append("headerProtheus", JSON.stringify(headerProtheus));
    if (logo) formData.append("file", logo[0].raw);

    try {
      const response = await ApiService.post("/companies", formData, {
        "Content-Type": "multipart/form-data"
      });
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  list: async function({ federalId, companyName }) {
    const queryFederalId = federalId ? `federalId=${federalId}` : "";
    const queryCompanyName = companyName ? `companyName=${companyName}` : "";
    let query = "";
    if (queryFederalId) query = `?${queryFederalId}`;
    if (queryCompanyName) {
      if (query.length !== 0) query += "&";
      else query += "?";
      query += `${queryCompanyName}`;
    }
    try {
      const response = await ApiService.get(`/companies${query}`);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  get: async function(id) {
    try {
      const response = await ApiService.get(`/companies/${id}`);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  update: async function({
    id,
    companyName,
    federalId,
    urlProtheus,
    headerProtheus,
    logo
  }) {
    const formData = new FormData();
    formData.append("companyName", companyName);
    formData.append("federalId", federalId);
    formData.append("urlProtheus", urlProtheus);
    formData.append("headerProtheus", JSON.stringify(headerProtheus));
    if (logo && logo.length > 0) formData.append("file", logo[0].raw);
    try {
      const response = await ApiService.put(`/companies/${id}`, formData, {
        "Content-Type": "multipart/form-data"
      });
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  delete: async function(id) {
    try {
      const response = await ApiService.delete(`/companies/${id}`);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  block: async function(id) {
    try {
      const response = await ApiService.patch(`/companies/block/${id}`);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  unblock: async function(id) {
    try {
      const response = await ApiService.patch(`/companies/unblock/${id}`);
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  addUsersToCompany: async function({ companyId, usersId }) {
    const data = { usersId };
    try {
      const response = await ApiService.post(
        `/companies/${companyId}/add-users`,
        data
      );
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  },
  deleteUsersToCompany: async function({ companyId, usersId }) {
    const data = { usersId };
    try {
      const response = await ApiService.delete(
        `/companies/${companyId}/delete-users`,
        data
      );
      return response.data;
    } catch (error) {
      const errorData = error.data || error;
      throw new RequestError(
        errorData.statusCode || errorData.status,
        errorData.message || errorData.statusText
      );
    }
  }
};

export { CompaniesService };
